export default __webpack_public_path__ + "static/media/bell_white.56640608.svg";